import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentHeader, Divider } from '_template';
import Breadcrumbs from 'components/Breadcrumbs';
import Helmet from 'components/Helmet';
import Actions from './components/Actions';
import EmailTemplateTable from './components/EmailTemplateTable';
import LimitedAccess from 'components/LimitedAccess';
import { RIGHTS } from 'constants/rights';

const EmailTemplateList = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet title={t<string>('EMAIL_TEMPLATE.MODEL_TITLE')} />
      <ContentHeader
        title={t('EMAIL_TEMPLATE.MODEL_TITLE')}
        actions={<Actions />}
        breadcrumbs={<Breadcrumbs section={t('EMAIL_TEMPLATE.MODEL_TITLE')} />}
      />
      <Divider sx={{ my: 4 }} />
      <LimitedAccess right={RIGHTS.EMAIL_TEMPLATE.LIST}>
        <EmailTemplateTable />
      </LimitedAccess>
    </>
  );
};

export default EmailTemplateList;
